export default function setCookie(cookieName, cookieValue, exdays = 1) {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  let expires = 'expires=' + d.toUTCString()

  const cookie = `${cookieName}=${cookieValue};${expires};path=/`
  document.cookie = cookie
}
